import FooterStyles from "./FooterStyle";

function Footer() {
  return <FooterStyles>GiroTech</FooterStyles>;
}

export default Footer;
